import { gql } from '@apollo/client';
import { User } from './types';

/**
 * GraphQL query to fetch a single user by ID
 */
export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      databaseId
      name
      email
      username
      registeredDate
      totpEnabled
      roles {
        nodes {
          name
        }
      }
      capabilities
    }
  }
`;

export interface GetUserData {
  user: User;
}

export interface GetUserVariables {
  id: string;
}
